(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const metaEl = document.getElementById('so-pdp-meta');
    const meta = metaEl ? JSON.parse(metaEl.textContent) : {};
    const displayTitle = meta.displayTitle || '';

    const pdpTitle = document.querySelector("main[data-template*='product'] .product-details h1");
    const pdpBadge = document.querySelector("[data-so-pdp-rating-badge]");

    if (pdpTitle && displayTitle) {
      pdpTitle.textContent = displayTitle;
    }

    const stickyTitle = document.querySelector('.sticky-add-to-cart__title');
    if (stickyTitle && displayTitle) {
      stickyTitle.textContent = displayTitle;
    }

    if (pdpTitle && pdpBadge) {
      pdpTitle.insertAdjacentElement('afterend', pdpBadge);
    }

    const detailsGroup = document.querySelector("main[data-template*='product'] .product-details > .group-block");
    const legacyAccordion = detailsGroup?.querySelector('.accordion:not(.so-pdp-accordions)');
    if (legacyAccordion) legacyAccordion.remove();
    const accordionsTemplate = document.getElementById('so-pdp-accordions-template');
    if (detailsGroup && accordionsTemplate) {
      detailsGroup.appendChild(accordionsTemplate.content.cloneNode(true));
    }

    const mobilePdp = window.matchMedia('(max-width: 767px)');
    const productInfo = document.querySelector("main[data-template*='product'] .product-information.section");
    const lifestyleSection = productInfo?.querySelector('.so-pdp-lifestyle');
    const desktopSizeGuideTemplate = document.getElementById('so-pdp-size-guide-desktop-template');

    const syncPdpSizeGuidePlacement = () => {
      productInfo?.querySelector('.so-pdp-size-guide--below-grid')?.remove();

      if (mobilePdp.matches) {
        return;
      }

      document
        .querySelector("main[data-template*='product'] .so-pdp-accordions .so-pdp-size-guide__detail")
        ?.remove();

      if (desktopSizeGuideTemplate && productInfo && lifestyleSection) {
        productInfo.insertBefore(desktopSizeGuideTemplate.content.cloneNode(true), lifestyleSection);
      }
    };

    syncPdpSizeGuidePlacement();

    const initJudgemeVisibility = () => {
      const reviewsSection = document.querySelector('.so-product-reviews');
      const ratingBadge = document.querySelector('[data-so-pdp-rating-badge]');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const badgeEl = document.querySelector('.jdgm-preview-badge');
        const reviewWidget = document.querySelector('.jdgm-review-widget');
        const badgeText = badgeEl?.innerText?.trim() || '';
        const hasRating = /\d/.test(badgeText) && !/no review|aucun avis|écrire/i.test(badgeText);
        const reviewCount = Number.parseInt(reviewWidget?.dataset?.numberOfReviews || '0', 10);
        const hasReviewItems = Boolean(
          reviewWidget?.querySelector('.jdgm-rev-widg__reviews .jdgm-rev, .jdgm-rev')
        );

        if (hasRating && ratingBadge) {
          ratingBadge.classList.add('has-reviews', 'is-ready');
        } else if (ratingBadge) {
          ratingBadge.classList.remove('is-ready', 'has-reviews');
          ratingBadge.style.display = 'none';
        }

        if (hasReviewItems || reviewCount > 0) {
          reviewsSection?.classList.add('has-reviews');
          reviewsSection?.removeAttribute('hidden');
        } else if (reviewsSection) {
          reviewsSection.remove();
        }

        if (attempts > 48 || (badgeEl && reviewWidget)) {
          window.clearInterval(timer);
        }
      }, 250);
    };

    initJudgemeVisibility();

  });

  } catch(e) { console.error(e); }
})();
})();
